jQuery(function($){

	let onclickParent = '.block-editor, .sc-field-editor';

	$("input[data-type='currency']").on({
		keyup: function() {
			formatCurrency($(this));
		},
		change: function() {
			formatCurrency($(this), 'blur');
		}
	});

	function hasAttr(el, attributeName) {
		var attr = el.attr(attributeName);
		return (typeof attr !== 'undefined' && attr !== false);
	}

	setTimeout(function(){
		triggerFormatCurrency();
	}, 10);

	function triggerFormatCurrency() {
		let form = $(onclickParent);

		form.find('.field').each(function(){
			$(this).find('input').each(function(){
				if(hasAttr($(this), 'data-type') && $(this).attr('data-type') == 'currency') {
					formatCurrency($(this), 'blur');
				}
			});
		});
	}

	function formatNumber(n) {
		return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	function rawFormatNumber(n) {
		return n.replace(/[^\d.-]/g, "");
	}

	function formatCurrency(input, blur) {
		var value = input.val();
		var hiddenInput = $('#' + input.attr('data-hidden-field'));

		if(value === '') return;

		var original_len = value.length;

		console.log(rawFormatNumber(value));

		var rawValue = rawFormatNumber(value);

		hiddenInput.val(rawValue);

		var caretPos = input.prop('selectionStart');

		if(value.indexOf('.') >= 0) {
			value = formatWithDecimal(rawValue, false);
		} else {
			value = '$' + formatNumber(rawValue);
			if (blur === 'blur') value += '.00';
		}
	  
		input.val(value);

		var updated_len = value.length;
		caretPos = updated_len - original_len + caretPos;
		input[0].setSelectionRange(caretPos, caretPos);
	}

	function formatWithDecimal(rawValue, returnRaw) {
		if(rawValue.indexOf('.') >= 0) {
			var decimalPos = rawValue.indexOf('.');

			var leftSide = rawValue.substring(0, decimalPos);
			var rightSide = rawValue.substring(decimalPos);

			leftSide = formatNumber(leftSide);
			rightSide = formatNumber(rightSide);

			if (blur === 'blur') rightSide += '.00';

			rightSide = rightSide.substring(0, 2);	

			if(rawValue < 0) leftSide = '-' + leftSide;


			return returnRaw ? rawFormatNumber(leftSide) + '.' + rawFormatNumber(rightSide) : '$' + leftSide + '.' + rightSide;	
		} else {
			return returnRaw ? rawFormatNumber(rawValue) : rawValue;
		}
	}
});